import Interaction, { InteractionType } from "../../models/interactions/Interaction";

const IF_OPERATOR_LABELS: Record<string, string> = {
  EQUAL: "Equal",
  NOTEQUAL: "Not Equal",
  LESS: "Less",
  LEQUAL: "Less or Equal",
  GREATER: "Greater",
  GEQUAL: "Greater or Equal",
};

const MATH_OPERATOR_LABELS: Record<string, string> = {
  ADD: "Add",
  SUBTRACT: "Subtract",
  MULTIPLY: "Multiply",
  DIVIDE: "Divide",
  MODULO: "Modulo",
};

function getTriggerLabel(triggerType?: string) {
  switch (triggerType) {
    case "onStart":
      return "On Take Start";
    case "onEnd":
      return "On Take End";
    default:
      return "Trigger";
  }
}

export function getSequenceNodeTitle(interaction: Interaction): string {
  if (interaction.type === InteractionType.Trigger) {
    return getTriggerLabel((interaction as { triggerType?: string }).triggerType);
  }

  if (interaction.type === InteractionType.If) {
    return (
      IF_OPERATOR_LABELS[(interaction as { operator?: string }).operator ?? ""] ??
      interaction.name
    );
  }

  if (interaction.type === InteractionType.Math) {
    return (
      MATH_OPERATOR_LABELS[(interaction as { operator?: string }).operator ?? ""] ??
      interaction.name
    );
  }

  return interaction.name;
}
